import { useSelector } from "react-redux";
import FormaArticulos from "./_FormaArticulos";

export default function Articulos() {
  const { step } = useSelector((state) => state.cotizacionesReducer.cotizacion);

  return step > 1 ? <FormaArticulos /> : <></>;
}
